import type { HttpClient } from '@shared/http/http-client';
import type {
  IEmployeeRepository,
  EmployeeListQuery,
} from '@domain/data-contracts/employee-repository.interface';
import type { Employee } from '@domain/models/employee.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapEmployeeDto,
  mapPaged,
  type EmployeeDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/employees';

export class EmployeeRepository implements IEmployeeRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: EmployeeListQuery): Promise<PagedResult<Employee>> {
    const response = await this.http.get<PagedDto<EmployeeDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapEmployeeDto);
  }
}

function pruneParams(query: EmployeeListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
